import React from 'react';
import { Link } from 'react-router-dom';
import './NoMatchPage.css';

const NoMatchPage = () => {
  return (
    <>
      <h3 id='not-found'>PAGE NOT FOUND</h3>
      <Link to='/'><h2 id='return-home'>RETURN TO HOME PAGE</h2></Link>
    </>
  );
};

export default NoMatchPage;
